import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Fillings } from 'src/app/entities/fillings.entity/fillings';

@Component({
  selector: 'app-reduction-fillings-form',
  templateUrl: './reduction-fillings-form.component.html',
  styleUrls: ['./reduction-fillings-form.component.css']
})
export class ReductionFillingsFormComponent implements OnInit {
 @Input()fillingsItmes!:Array<Fillings>
  @Output()fillingsItmesChange:EventEmitter<Array<Fillings>>=new EventEmitter()
disabled:boolean=false
  constructor() { }
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    // height: '60rem',
    minHeight: '0',
    maxHeight: 'auto',
    width: '50rem',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,

    showToolbar: true,
    placeholder: '',
    defaultParagraphSeparator: '',

    defaultFontName: '',
    defaultFontSize: '',

    /* customClasses: [{
      name: 'table',
      class: '<!--',
      tag: 'table class="table table-bordered"><tr><td>&nbsp;</td><td>&nbsp;</td></tr><tr><td>&nbsp;</td><td>&nbsp;</td></tr></table> <!-- '
  }],*/
    sanitize: false,
  };
  ngOnInit(): void {
  }


  addFillingsItem(): void {

    this.fillingsItmes.push(new Fillings({}));
    this._change()
  }

  deleteFillingsItem(index: number): void {
    this.fillingsItmes.splice(index, 1);
    this._change()
  }
  _change(){
    this.fillingsItmesChange.emit(this.fillingsItmes)
  }
}
